import { render, staticRenderFns } from "./CustomerDetail-salesStats.vue?vue&type=template&id=ebec380e&scoped=true"
import script from "./CustomerDetail-salesStats.vue?vue&type=script&lang=js"
export * from "./CustomerDetail-salesStats.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetail-salesStats.vue?vue&type=style&index=0&id=ebec380e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebec380e",
  null
  
)

export default component.exports